import React from "react";
import PostCard from "../postCard/PostCard";
import {useRouter} from "next/router";
import styles from "./OriginalPosts.module.scss";


const OriginalPostsItem = React.forwardRef(
  function OriginalPostsItem(props, ref) {
    const router = useRouter();
    return (
      <PostCard {...props}
                type={"original"}
                tagsColor={true}
                className={styles.originalPosts__item}
                onClick={() => router.push(props.href)}
                ref={ref}
      />
    );
  });
export default OriginalPostsItem;
OriginalPostsItem.propTypes = {};

